<template>
  <div class="print-page">
    <jewelry-certificate v-if="certData" :item="certData" />
    <div v-else class="no-data">Sertifika verisi bulunamadı.</div>
  </div>
</template>

<script>
import JewelryCertificate from "@/components/JewelryCertificate.vue";

export default {
  components: { JewelryCertificate },
  data: () => ({
    certData: null,
  }),
  mounted() {
    this.$store.commit("SET_LAYOUT", "empty-layout");
    try {
      const raw = localStorage.getItem("jewelryCertificateData");
      if (raw) {
        this.certData = JSON.parse(raw);
      }
    } catch (e) {
      console.error("Sertifika verisi okunamadı:", e);
    }
    this.$nextTick(() => {
      window.print();
    });
  },
};
</script>

<style scoped>
.print-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
}

.no-data {
  padding: 40px;
  font-size: 18px;
  color: #666;
}

@media print {
  .print-page {
    background: white;
    padding: 0;
  }
}
</style>

<style>
/* A6 boyutu: 148mm x 105mm (landscape) */
@page {
  size: A6 landscape;
  margin: 0.5cm;
}
</style>
